

/* profile-menu-dialog.component.ts */
import { Component, inject } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import * as packageJson from './../../../../../package.json'
import { Store } from '@ngrx/store';
import { AuthUserActions, authUserFeature } from '../../../store/authUser.store';
import { MatIcon } from "@angular/material/icon";
import { filter, lastValueFrom, take, takeUntil } from 'rxjs';
import { Base } from '../../wrapper/base-wrapper.component';


export interface ProfileMenuData {}

interface MenuGroup {
  heading: string;
  items: { label: string; route?: string[], pending?: boolean }[];
}

@Component({
  selector: 'msh-profile-menu',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, RouterModule, MatIcon],
  template: `
    <!-- profile-menu-dialog.component.html -->
    <div class="dialog-container bg-back">
      <div class="grid grid-cols-2 gap-6 p-6">
        @for (group of menu; track group) {
          <div class="flex flex-col">
            <div class="text-navy/85 uppercase font-light tracking-widest text-lg mb-3">{{ group.heading }}</div>
            @for (item of group.items; track item) {
              @if(item.pending){
                <div
                  class="justify-start text-copy transition-colors duration-300 px-0 py-1 opacity-50"
                  >
                  {{ item.label }}
                </div>
              } @else {
                <div
                  mat-button
                  class="justify-start cursor-pointer text-copy hover:text-orange-400 transition-colors duration-300 px-0 py-1"
                  [routerLink]="item.route"
                  (click)="close()"
                  >
                  {{ item.label }}
                </div>
              }
            }
          </div>
        }
      </div>
      <div class="grid grid-cols-3 text-navy/85 gap-6 p-6 bg-navy-50 border-t border-navy/25 px-6 py-2 shadow-[inset_0px_8px_12px_-9px_rgba(0,_0,_0,_0.35)]">
        <div>
          <mat-icon class=" cursor-pointer" (click)="toggleMode()">{{!isDarkMode ? 'dark_mode' : 'light_mode'}}</mat-icon>
        </div>
        <div class="empty text-xs">
          Version {{packageJson.version}}
        </div>
        <div class=" text-right cursor-pointer hover:text-orange-400 transition-colors duration-300" (click)="logout()">
          Logout
        </div>
      </div>
    </div>
    `,
  styles: ``
})
export class ProfileMenuDialog extends Base<ProfileMenuDialog> {
  private readonly dialogRef = inject(MatDialogRef<ProfileMenuDialog>);
  packageJson = packageJson;
  isDarkMode = true;

  constructor(
    private store: Store,
    private authService: AuthService,
  ){
    super();
    this.store.select(authUserFeature.selectUser).pipe(filter(u=>!!u), takeUntil(this.$destroy)).subscribe(authUser=>{
      console.log({authUser})
      this.isDarkMode = authUser.preferences.isDarkMode;
    })
  }
  readonly menu: MenuGroup[] = [
    {
      heading: 'Location',
      items: [
        { label: 'Details', route: ['/location', 'details'] },
        { label: 'Banking', route: ['/location', 'banking'], pending: true },
        { label: 'Shipping', route: ['/location', 'shipping'], pending: true },
        { label: 'Users', route: ['/account','manage','users'] },
        { label: 'Discounts', route: ['/location', 'discounts'], pending: true },
      ],
    },
    {
      heading: 'Profile',
      items: [
        { label: 'My Listings', route: ['/profile', 'listings'] },
        { label: 'Details', route: ['/profile', 'details'] },
        { label: 'Settings', route: ['/profile', 'settings'], pending: true },
        { label: 'Switch Locations', route: ['/account','manage'] },
        { label: 'Invites', route: ['/invite'] },
      ],
    },
  ];

  logout(): void {
    this.authService.logout();
    this.store.dispatch(AuthUserActions.logOut());
    this.dialogRef.close();
  }

  async toggleMode(){
    this.isDarkMode = !this.isDarkMode; 
    const authUser = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(take(1)))
    if(!authUser || !authUser.id) return;
    const preferences = JSON.parse(JSON.stringify(authUser?.preferences)) || {};
    preferences.isDarkMode = this.isDarkMode;
    console.log({preferences: preferences});
    
    this.authService.saveUser({id: authUser.id, preferences })
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
